const theme = {
  colors: {
    black: '#000000',
    blacks: {
      ipBlack1: '#222321',
      ipBlack4: '#6D706B',
      ipBlack5: '#919390',
      ipBlack6: '#E3E3E2',
      ipBlack7: '#F8F8F8',
      ipBlack8: '#FFFFFF'
    },
    brand: {
      primary: '#26E888'
    },
    green: {
      light: '#2CD696',
      lighter: '#00EA84'
    },
    greys: {
      dark: '#979797',
      darker: '#606060',
      darkest: '#1D1D1B',
      lighty: '#E3E3E2',
      lightest: '#FFFFFF'
    },
    red: {
      error: '#E84933'
    },
    infoOrange: '#FFBF85',
    white: '#FFFFFF'
  },
  fonts: {
    families: {
      primary: 'inter',
      secondary: 'inter'
    },
    textSmallHeight24: 'normal 500 12px/24px inter',
    h1: 'normal 700 20px/28px inter-bold',
    h1Inter: 'normal 700 20px/24px inter-bold',
    h2Inter: 'normal 700 16px/24px inter',
    titleHeight24Bold: 'normal 700 24px/24px inter-bold',
    textHugeBoldHeight21: 'normal 700 18px/21px inter-bold',
    textMiddleNormal: 'normal 500 14px/16px inter',
    textMiddleBold: 'normal 700 14px/16px inter',
    textSmallHeight16: 'normal 500 12px/16px inter',
    textSmall: 'normal 500 12px/20px inter',
    textSmallWeight600: 'normal 600 12px/20px inter'
  }
};

export default theme;
